import * as React from "react";
import Utility from "../../../model/utility/Utility";
import DataGrid from '../../../hiberUiKit/src/organisms/DataGrid/DataGrid';
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";

interface Props {
	utilities: Utility[];
	onRowClick: (utility: Utility) => void;
	onDelete: (utilityId: string) => void;
}

export default class UtilitiesTable extends React.Component<Props> {

	render() {
		return (
			<DataGrid hasPointer hasHover>
				<thead>
					<tr>
						<th>id</th>
						<th>Name</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{this.props.utilities.map(utility => (
						<tr key={utility.id} onClick={() => this.props.onRowClick(utility)}>
							<td>{utility.id}</td>
							<td>{utility.name}</td>
							<td>
								<ButtonSecondary
									label={"Delete"}
									onClick={(e) => {
										e.stopPropagation();
										this.props.onDelete(utility.id);
									}}
								/>
							</td>
						</tr>
					))}
				</tbody>
			</DataGrid>
		);
	}
}
